export default __webpack_public_path__ + "static/media/FallbackBG.eec2e6e6.png";